<script setup>
import { ref } from 'vue'
// Your images
import heroImg from '@/assets/bg.jpg'
import tulImg from '@/assets/categories/tul.jpg'
import fonImg from '@/assets/categories/fon.jpg'
import ceyizImg from '@/assets/categories/ceyiz.jpeg'
import storImg from '@/assets/categories/stor.jpg'
import smalImg from '@/assets/aynur.jpeg'
const categories = ref([
  { id: '01', title: 'Tül Perdeler', link: '/tul', img: tulImg },
  { id: '02', title: 'Fon Perdeler', link: '/fon', img: fonImg },
  { id: '03', title: 'Stor Perdeler', link: '/stor', img: storImg },
  { id: '04', title: 'Çeyiz Ürünleri', link: '/ceyiz', img: ceyizImg }
])
</script>

<template>
  <div class="home-wrapper">
    
    <section class="main-hero" :style="{ backgroundImage: `url(${heroImg})` }">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <span class="establishment">SINCE 2023</span>
        <h1 class="brand-title">AYNURA HOME</h1>
        <div class="brand-line"></div>
        <p class="brand-slogan">Evinizin Zarafetine Özel Dokunuşlar</p>
      </div>
      <div class="scroll-down">
        <span>KEŞFET</span>
        <div class="vertical-line"></div>
      </div>
    </section>

    <section class="container section-padding">
      <div class="hero-header">
        <span class="subtitle">PREMIUM KOLEKSİYON</span>
        <h2>Pencerenize Özel Dokunuşlar</h2>
        <p class="hero-desc">Atölyemizden, evinize uzanan kaliteli ve ulaşılabilir şıklık.</p>
      </div>

      <div class="category-grid">
        <router-link 
          v-for="cat in categories" 
          :key="cat.id" 
          :to="cat.link" 
          class="cat-item"
        >
          <div class="img-reveal">
            <img :src="cat.img" :alt="cat.title" />
            <div class="img-overlay"></div>
          </div>
          <div class="cat-info">
            <span class="cat-num">{{ cat.id }}</span>
            <span class="cat-title">{{ cat.title }}</span>
            <div class="cat-line"></div>
          </div>
        </router-link>
      </div>
    </section>
    <section class="story-layer">
      <div class="container inner-flex">
        <div class="story-text">
          <span class="label">BİZ KİMİZ?</span>
          <h2>Aracı Yok, Fabrika Değil. <br/> <span class="green">Sadece El Emeği.</span></h2>
          <p>
            Mersin'deki küçük mağazamızda kumaşları bizzat seçiyor, ölçülerinizi yerinde alıyor 
            ve kendi atölyemizde dikiyoruz. Dev mağazaların yüksek maliyetlerini fiyatlarımıza 
            yansıtmıyor, kaliteyi daha ulaşılabilir kılıyoruz.
          </p>
        </div>
        
        <div class="story-image-mini">
          <img :src="smalImg" alt="Atölye">
        </div>
      </div>
    </section>

    <section class="container section-padding">
      <div class="process-grid">
        <div class="process-card">
          <span class="big-num">01</span>
          <h3>Ücretsiz Keşif</h3>
          <p>Evinize gelip ölçülerinizi titizlikle alıyor, mekanın ışığına göre kumaş öneriyoruz.</p>
        </div>
        <div class="process-card">
          <span class="big-num">02</span>
          <h3>Kendi Atölyemiz</h3>
          <p>Seçtiğiniz model, usta ellerde tam istediğiniz boyda ve pile sıklığında dikiliyor.</p>
        </div>
        <div class="process-card">
          <span class="big-num">03</span>
          <h3>Hızlı Teslim</h3>
          <p>Ütülenmiş ve hazır perdelerinizi kısa sürede hazırlayıp teslim ediyoruz.</p>
        </div>
      </div>
    </section>

    <section class="cta-layer">
      <div class="container">
        <div class="cta-content">
          <h2>Bir sorunuz mu var?</h2>
          <p>Hemen WhatsApp üzerinden bizimle iletişime geçin.</p>
          <a href="https://wa.me/905444862202" target="_blank" class="cta-button">
            WHATSAPP İLE SORUN 
          </a>
        </div>
      </div>
    </section>
    <section class="map-section container section-padding">
      <div class="inner-flex">
        <div class="story-text">
          <span class="label">KONUMUMUZ</span>
          <h2>Atölyemizde <br/> <span class="green">Bir Kahveye Bekleriz.</span></h2>
          <p>
            Kumaşlarımızı yakından görmek ve modellerimizi incelemek için Mersin'deki 
            atölyemize buyurun.
          </p>
          <div class="address-detail">
            <strong>Adres:</strong> Sağlık, 206. Cd. No:22, 33080 Toroslar/Mersin
          </div>
        </div>
        
        <div class="map-square-wrapper">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d199.63453716646285!2d34.62055128487266!3d36.81486316158757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1527f3f053a68c9d%3A0xf475bfd457a6fed1!2sAynura%20Home!5e0!3m2!1str!2str!4v1773088366353!5m2!1str!2str" 
              width="100%" 
              height="400"
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.main-hero {
  height: 100vh;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-attachment: fixed; 
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  text-align: center;
}

.hero-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.35); 
}

.hero-content {
  position: relative;
  z-index: 2;
}

.establishment {
  font-size: 0.7rem;
  letter-spacing: 6px;
  display: block;
  margin-bottom: 15px;
  font-weight: 300;
}

.brand-title {
  font-size: 5rem;
  font-weight: 800;
  letter-spacing: 12px;
  margin: 0;
  text-transform: uppercase;
}

.brand-line {
  width: 60px;
  height: 2px;
  background: #2d5a27; 
  margin: 25px auto;
}

.brand-slogan {
  font-size: 1.2rem;
  font-weight: 300;
  letter-spacing: 4px;
  opacity: 0.9;
}

.scroll-down {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.7;
}

.scroll-down span { font-size: 0.6rem; letter-spacing: 3px; }
.vertical-line { width: 1px; height: 50px; background: white; margin: 15px auto 0; }

.home-wrapper { background: #fff; color: #1a1a1a; overflow-x: hidden; }
.container { max-width: 1300px; margin: 0 auto; padding: 0 40px; }
.section-padding { padding: 120px 0; }
.green { color: #2d5a27; }

.hero-header { margin-bottom: 60px; }
.subtitle { color: #2d5a27; font-size: 0.8rem; font-weight: 700; letter-spacing: 4px; display: block; margin-bottom: 15px; }
h2 { font-size: 3rem; font-weight: 800; margin: 0; line-height: 1.1; letter-spacing: -1px; }
.hero-desc { color: #888; font-size: 1.2rem; margin-top: 20px; max-width: 500px; }

.category-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 20px; 
}
.cat-item { text-decoration: none; color: inherit; }
.img-reveal { position: relative; overflow: hidden; aspect-ratio: 4/5; background: #f4f4f4; }
.img-reveal img { width: 100%; height: 100%; object-fit: cover; transition: 1.5s cubic-bezier(0.19, 1, 0.22, 1); }
.cat-info { padding: 25px 0; }
.cat-num { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; font-weight: 700; }
.cat-title { font-size: 1.3rem; font-weight: 700; }
.cat-line { width: 0; height: 2px; background: #2d5a27; margin-top: 10px; transition: 0.4s; }

.cat-item:hover img { transform: scale(1.1); }
.cat-item:hover .cat-line { width: 60px; }

.story-layer { 
  background: #fcfcfc; 
  padding: 60px 0; 
  border-top: 1px solid #f0f0f0; 
  border-bottom: 1px solid #f0f0f0; 
}
.label { color: #2d5a27; font-weight: 800; font-size: 0.7rem; letter-spacing: 3px; }
.story-text h2 { 
  font-size: 2.2rem; 
  margin: 10px 0; 
  font-weight: 800; 
}

.process-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 80px; }
.big-num { font-size: 4rem; font-weight: 900; color: #f0f0f0; display: block; margin-bottom: -30px; }

.cta-layer { background: #1a1a1a; color: #fff; padding: 100px 0; text-align: center; }
.cta-button { display: inline-block; color: #2d5a27; text-decoration: none; font-weight: 800; border-bottom: 2px solid #2d5a27; padding-bottom: 8px; }

.inner-flex {
  display: flex;
  align-items: center; 
  justify-content: space-between;
  gap: 60px; 
}

.story-text {
  flex: 1; 
}

.story-text p {
  margin: 0;
  line-height: 1.6;
}

.story-image-mini {
  flex: 0 0 250px; 
}

.story-image-mini img {
  width: 100%;
  height: 250px; 
  object-fit: cover;
}

.map-section {
  border-top: 1px solid #f7f7f7;
}

.address-detail {
  margin-top: 25px;
  font-size: 0.9rem;
  color: #555;
  border-left: 2px solid #2d5a27;
  padding-left: 15px;
}

.map-square-wrapper {
  flex: 0 0 500px; /* Karenin genişliği */
  aspect-ratio: 1 / 1; /* Mükemmel kare yapar */
  overflow: hidden;
  transition: 0.6s cubic-bezier(0.19, 1, 0.22, 1);
}

.map-square-wrapper:hover {
  filter: grayscale(0%) opacity(1);
}

.map-square-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 900px) {
  .brand-title { font-size: 2.5rem; letter-spacing: 6px; }
  .category-grid, .process-grid { 
    grid-template-columns: 1fr; 
  }

  .cat-item {
    width: 90%;
    height: auto;
    margin: auto;
  }

  h2 { font-size: 2.2rem; }
  .inner-flex {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  
  .story-image-mini {
    flex: 0 0 auto;
    width: 100%;
    max-width: 280px; 
  }

  .map-square-wrapper {
      flex: 0 0 auto;
      width: 100%;
      max-width: 300px; /* Mobilde biraz daha küçük kare */
      margin: 40px auto 0;
    }
}
</style>
